// extracted by mini-css-extract-plugin
module.exports = {"mainheader":"Header_mainheader__S4h9j","container":"Header_container__21wXn"};